import React, { FC, memo } from 'react'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { EImageAlign, IBlockWithImageBoxes } from '../types'
import SC from '../base/BlockWithImageBoxes.styles'
import ButtonRegEvent from '../../ButtonRegEvent/desktop'

const { Block, Image } = SC

const BlockWithImageBoxes: FC<IBlockWithImageBoxes> = (props) => {
  const { title, items, button } = props

  return (
    <Block>
      <Spacing spacing='uxlarge' />

      {title && <Heading h2={title} spacing='large' />}

      <Grid>
        {items.map((card) => {
          if (card.imageAlign === EImageAlign.right) {
            return (
              <>
                <GridCol uxs={card.image ? 12 : 24}>
                  {card.title && <Heading h2={card.title} />}

                  {card.text && <Text>{card.text}</Text>}
                </GridCol>

                {card.image && (
                  <GridCol uxs={12}>
                    <Image src={card.image} />
                  </GridCol>
                )}
              </>
            )
          }

          return (
            <>
              {card.image && (
                <GridCol uxs={12}>
                  <Image src={card.image} />
                </GridCol>
              )}

              <GridCol uxs={card.image ? 12 : 24}>
                {card.title && <Heading h3={card.title} />}

                {card.text && <Text>{card.text}</Text>}
              </GridCol>
            </>
          )
        })}
      </Grid>

      {button && (
        <>
          <Spacing spacing='xlarge' />

          <ButtonRegEvent color={button.color} />
        </>
      )}
    </Block>
  )
}

export default memo(BlockWithImageBoxes)
